module.exports = __webpack_public_path__ + "static/media/salad.a3c0030a.jpg";